export default __webpack_public_path__ + "static/quality_assurance-840ed7dbfc5b4f8f79b9bdcfe0f9f2d8.jpg";